import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import * as acts from "../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import DashboardTableSkaleton from "./Skeletons/DashboardTableSkaleton";
import "./uploadedFilesList.scss";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import DateRangePicker from "./DateRangePicker";
import AutorenewSharpIcon from "@mui/icons-material/AutorenewSharp";
import CloseIcon from "@mui/icons-material/Close";
import Label from "./Label/Label";

function UploadedFilesList({
  openUploadedFilePreviewDialog,
  setOpenUploadedFilePreviewDialog,
}) {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // const [page, setPage] = useState(0);
  // const [pageCount, setPageCount] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(100);
  const [drugType, setDrugType] = useState("");
  const [clearDateRange, setClearDateRange] = useState(false);

  const uploadedFilesList = useSelector(
    (state) => state.prePro.uploadedFilesList
  );
  const fileType = useSelector((state) => state?.prePro?.folderType);

  // const apiStatus = useSelector((state) => state?.prePro?.apiStatus);

  useEffect(() => {
    dispatch(
      acts.getUploadedFilesList({
        // page: page + 1,
        // page_size: rowsPerPage,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    // , page, rowsPerPage
  ]);

  useEffect(() => {
    // if (uploadedFilesList?.data?.data?.length > 0) {
    setList(uploadedFilesList?.data?.data);
    // }
    // setPageCount(uploadedFilesList?.total_count);
    // }, [uploadedFilesList?.data, uploadedFilesList?.total_count]);
  }, [uploadedFilesList?.data?.data]);

  useEffect(() => {
    const filtered = list?.filter((file) => {
      const matchesFileName = searchQuery
        ? file.file_name.toLowerCase().includes(searchQuery.toLowerCase())
        : true;
      const matchesDrugType = drugType ? file.drug_type === drugType : true;

      return matchesFileName && matchesDrugType;
    });
    setFilteredFiles(filtered);
  }, [list, searchQuery, drugType]);

  useEffect(() => {
    dispatch(acts.getDrugType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handlePageChange = (event, value) => {
  //   setPage(value);
  //   dispatch(
  //     acts.getUploadedFilesList({
  //       // page: value + 1,
  //       // page_size: rowsPerPage,
  //     })
  //   );
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(event.target.value);
  //   setPage(0);
  // };

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleDrugTypeChange = (event) => {
    setDrugType(event.target.value);
    localStorage.setItem("drugType", event.target.value);
  };

  const handleRefresh = () => {
    setSearchQuery("");
    setDrugType("");
    setClearDateRange(true); // Trigger clearing the date range

    dispatch(
      acts.getUploadedFilesList({
        // page: page + 1,
        // page_size: rowsPerPage,
      })
    );

    setTimeout(() => setClearDateRange(false), 0);
  };

  // const handleFolderChange = (event) => {
  //   setDrugType(event.target.value);
  //   localStorage.setItem("drugType", event.target.value);
  // };

  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? `${moment(startDate).format("YYYY-MM-DD")}T00:00:00.000Z` : "";
    const formattedEndDate =
      endDate !== "" ? `${moment(endDate).format("YYYY-MM-DD")}T23:59:00.000Z` : "";

    dispatch(
      acts.getUploadedFilesList({
        formattedStartDate,
        formattedEndDate,
      })
    );
  };

  return (
    <Dialog
      open={openUploadedFilePreviewDialog}
      onClose={() => setOpenUploadedFilePreviewDialog(false)}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          height: "100vh",
        },
      }}
    >
      <DialogTitle style={{ paddingRight: "40px" }}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
        >
          <Grid item xs={7}>
            <Grid container alignItems="center" spacing={2}>
              {/* Title */}
              <Grid item style={{ paddingRight: "20px" }}>
                <Typography variant="h6" className="title">
                  Uploaded Files
                </Typography>
              </Grid>

              <Grid item xs={6} sm={4}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  placeholder="Search file name"
                  value={searchQuery}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={4}>
                <Select
                  value={drugType}
                  onChange={handleDrugTypeChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Select Drug Type</em>
                  </MenuItem>
                  {fileType?.map((value) => (
                    <MenuItem value={value.name} key={value.name}>
                      {value.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={5}>
            <Grid
              container
              alignItems="center"
              justifyContent="flex-end"
              spacing={1}
            >
              <Grid item xs={10} style={{ zIndex: 999 }}>
                <DateRangePicker
                  filterByDate={filterByDate}
                  clear={clearDateRange}
                />
              </Grid>

              <Grid item xs={2}>
                <IconButton onClick={handleRefresh} aria-label="refresh">
                  <AutorenewSharpIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <IconButton
          aria-label="close"
          onClick={() => setOpenUploadedFilePreviewDialog(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container>
          <Grid item style={{ width: "100%" }}>
            <Box className="">
              {uploadedFilesList?.loading === true ? (
                <DashboardTableSkaleton />
              ) : uploadedFilesList?.loading === false &&
                uploadedFilesList?.data?.data?.length > 0 ? (
                <Box className="">
                  <Box className="">
                    <TableContainer className="file-table-container">
                      <Table
                        stickyHeader
                        className="file-table-output"
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" className="index-cell">
                              Index
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              File Name
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              File Type
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              Drug Type
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              Created on
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              Updated on
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredFiles?.map((list, index) => (
                            <TableRow key={list.id} className="row-wrap">
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="left">
                                {list.file_name}
                              </TableCell>
                              <TableCell align="left">
                                {list.file_type}
                              </TableCell>
                              <TableCell align="left">
                                {list.drug_type}
                              </TableCell>
                              <TableCell align="left">
                                {list?.created_on}
                              </TableCell>
                              <TableCell align="left">
                                {list?.updated_on}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              ) : (
                <div className="no-data">
                  <Label
                    text="No Data Found"
                    fontSize="16"
                    fontWeight="600"
                    padding="20px"
                  />
                </div>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default UploadedFilesList;
